export default {
    scheduled_reports_report_name: "Nombre del Reporte",
    scheduled_reports_report_type: "Tipo del Reporte",
    scheduled_reports_scheduled_at: "Programado en",
    scheduled_reports_completed_on: "Completado en",
    scheduled_reports_format: "Formato",
    scheduled_reports_send_by_email: "Enviar por Correos",
    scheduled_reports_status: "Estado",
    scheduled_reports_args_path: "Args Ruta",
    scheduled_reports_params: "Parámetros",
    scheduled_reports_emails: "Correos",
    scheduled_reports_yes: "Si",
    scheduled_reports_no: "No",
    scheduled_show_params: "Mostrar Parámetros",
    scheduled_download_report: "Descargar el Reporte",
    scheduled_no_data_available: "no hay datos disponibles",
    scheduled_created_on: "Creado en",
    scheduled_last_process_update: "Última Actualización del Proceso",
    scheduled_error: "Error",
    scheduled_account: "Cuenta",
}